var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-lg pointer",class:'fa-' + _vm.icon,attrs:{"title":_vm.uLang('app.send_invoice_reminder')},on:{"click":_vm.sendReminder}})
}
var staticRenderFns = []

export { render, staticRenderFns }